import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Routes, Route } from 'react-router-dom';

import CategoriesPreview from '../categories-preview/categories-preview.component';
import Category from '../category/category.component';
import { fetchCategoriesStart } from '../../store/categories/category.action';

const Shop = () => {
  const dispatch = useDispatch();

  // the following useEffect only needs to be run once per categories collection updating
  // useEffect(() => {
  //   addCollectionAndDocuments("categories", SHOP_DATA, "title");
  // }, []);
  
  useEffect(() => {
    dispatch(fetchCategoriesStart());
  }, [dispatch]);
  
  return (
    <Routes>
      <Route index element={<CategoriesPreview />} />
      <Route path=":category" element={<Category />} />
    </Routes>
  );
};

export default Shop;
